<template>
  <div class="home">
    <Introduction/>
    <a href="#" class="go-top">
      <v-icon name="arrow-up"/> 
    </a>
    <Cooperative/>
    <About/>
    <!-- <Please/> -->
  </div>
</template>

<script>
import Introduction from './Introduction'
import About from './About'
import Cooperative from './Cooperative'
// import Please from './Please'

export default {
  name: 'home',
  components: {
    Introduction,
    About,
    Cooperative
    // Please,
  }
}
</script>

<style lang="scss" scoped>
.home {
  width: 100%;
  height: 100%;

  .go-top{
    position: fixed;
    display: block;
    cursor: pointer;
    bottom: 30px;
    right: 0;
    color: #ffffff;
    background-color: #e36cd9;
    z-index: 99;
    width: 45px;
    text-align: center;
    height: 45px;
    border-radius: 10px 0 0 10px;
    line-height: 46px;
    -webkit-transition: 0.5s;
    transition: 0.5s;
    
    &:hover{
      background-color: #44ce6f;
    }
  }
}
</style>
